export const OPEN_SNACKBAR = 'EMAIL/OPEN_SNACKBAR';
export const OPEN_SNACKBAR_ERROR = 'EMAIL/OPEN_SNACKBAR_ERROR';
export const CLOSE_SNACKBAR = 'EMAIL/CLOSE_SNACKBAR';



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/Snackbar/actionTypes.js